var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c4799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05387e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcd2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e52347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d01739"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.377143 -1.752381)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.285714 1.52381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.09256804 7.85062827 16.00000006-7.61904764h-16.00000006z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.09256804 7.85062827 16.00000006-7.61904764h-16.00000006z",
    fill: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.047619 2.285714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.99732994 2.89824729-.58313665.64591167.04438863-.86906841-.8690684.04438864.64591166-.58313666-.64591166-.58313666.8690684.04438864-.04438863-.86906841.58313665.64591167.58313667-.64591167-.04438864.86906841.86906841-.04438864-.64591168.58313666.64591168.58313666-.86906841-.04438864.04438864.86906841z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.99732994 2.89824729-.58313665.64591167.04438863-.86906841-.8690684.04438864.64591166-.58313666-.64591166-.58313666.8690684.04438864-.04438863-.86906841.58313665.64591167.58313667-.64591167-.04438864.86906841.86906841-.04438864-.64591168.58313666.64591168.58313666-.86906841-.04438864.04438864.86906841z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.285714 5.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.09256804 7.85062827h16.00000006v-7.61904764z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.09256804 7.85062827h16.00000006v-7.61904764z",
    fill: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.761905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.37774046 14.7077886 15.47904814-9.67238287-3.0017739-4.80384254-15.47904821 9.67238279z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.37774046 14.7077886 15.47904814-9.67238287-3.0017739-4.80384254-15.47904821 9.67238279z",
    fill: "url(#a)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m2.01874005 14.9393517 18.73782455-11.70869229-2.01874-3.23065941-18.7378246 11.7086923z",
    fill: "url(#f)",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/NA.2baa67372305cd18e3b36706c89fb9a6.svg";
export { ForwardRef as ReactComponent };